function initActivity(){
    initSelectize();
    initSelectizeAjax();
    initTypeaheadAjax();
    initDatePicker();
    initTimePicker();
    initSelectPicker();
    initActivityButtons();

   // var finished = $('#activity-form #status:checked').val();

    var saveButtonView = function(){
        $('.inaction').addClass('hidden');

        if ($('#activity-form #status2').is(':checked') || $('#activity-form #status').is(':checked') )    $('.inaction').removeClass('hidden');
    }

    $('#activity-form #status').change(function(){
        if($(this).is(':checked')){
            $('#finished-action').show();
            $('#status2').prop("checked", false).trigger('change');
        }else{
            $('#finished-action').hide();
        }
        saveButtonView();
    });

    $('#activity-form #status2').change(function(){
        if($(this).is(':checked')){
            $('#canceled-action').show();
            $('#activity-form #status').prop("checked", false).trigger('change');

        }else{
            $('#canceled-action').hide();
        }
        saveButtonView();
    });




    $('#activity-form #alert').change(function(){
        if($(this).is(':checked')){
            $('#notify-action').show();
        }else{
            $('#notify-action').hide();
        }

    });


    $('#activity-form input[name="action_id"]').change(function(){
        var value = $(this).val();
        var text = $.trim($(this).parent().text());

       $('#activity-form .changeable').hide();
        $('#activity-form .changefor-'+value).show();
        var name = $('#activity-form #name').val();
        if (name == '' || $('#activity-form #name').attr('data-autoset') == name) {
            $('#activity-form #name').val(text);
            $('#activity-form #name').attr('data-autoset',text);
        }

    });


    $('#activity-form #status').trigger('change');
    $('#activity-form #status2').trigger('change');
    $('#activity-form #alert').trigger('change');
    $('#activity-form input[name="action_id"]:checked').trigger('change');

    if ($('#activity-form input[name="id"]').val()== '' ){

    }



        $('#activity-form #duration').on('change', function(){
            $(this).removeClass('pristine');
        });

        $('#activity-form .btn-group .btn').on('click', function () {
            if ($(this).attr('data-duration') != undefined && $('#activity-form #duration').hasClass('pristine')) {
                $('#activity-form #duration').val($(this).attr('data-duration'));
            }
        })
}

function initActivityButtons(){


    $('#saveAction').click(function(){

        var target = $(this).attr('data-targetform');
        var $target = $(target);
        var l = Ladda.create(this);
        l.start();

        $.post($target.attr('action'), $target.serialize())
            .done(function(data){
                if (data.status){
                    //$('#filter').trigger('filter:refresh');
                    $('body').trigger('activity:added');
                    $('.slidePanel-close').trigger('click');
                }else{
                    window.errorsCheck(data);
                }

            })
            .always(function() { l.stop(); });



    });

    $('#saveActionActivity').click(function(){

        var target = $(this).attr('data-targetform');
        var $target = $(target);
        var l = Ladda.create(this);
        l.start();

        $.post($target.attr('action'), $target.serialize())
            .done(function(data){
                if (data.status){
                    //$('#filter').trigger('filter:refresh');
                    $('body').trigger('activity:added');
                    if (data.html != undefined){
                        $('#activity-wrapper').html(data.html);
                    }else {
                        $('.slidePanel-close').trigger('click');
                    }
                }else{
                    window.errorsCheck(data);
                }

            })
            .always(function() { l.stop(); });

    });

}